import { LOGIN_PROVIDERS, OPERATOR_LINE, PAYMENT_PROVIDER, PROCESSOR_GROUPS, SERVICE_NAME } from '../operator';
import type { LegalDoc } from '../types';

/*
 * С 01.09.2025 согласие оформляется отдельно от оферты и политики (ч. 1 ст. 9
 * 152-ФЗ в ред. 156-ФЗ): отдельный документ и отдельное действие пользователя —
 * своя галочка или кнопка, не совмещённая с принятием оферты. Состав — ч. 4 ст. 9.
 */
export const consent: LegalDoc = {
  id: 'consent',
  title: 'Согласие на обработку персональных данных',
  description: `Текст согласия на обработку персональных данных пользователя ${SERVICE_NAME}.`,
  blocks: [
    {
      p: 'Согласие даётся отдельно от иных документов — от публичной оферты и Политики обработки персональных данных. Принятие оферты согласием не является и его не заменяет.',
    },
    {
      p: `Я, пользователь сервиса ${SERVICE_NAME} (Telegram-бот, мини-приложение в Telegram, сайт и веб-приложение), действуя свободно, своей волей и в своём интересе, даю согласие Оператору на обработку моих персональных данных на следующих условиях. Оператор — ${OPERATOR_LINE}. Меня идентифицирует идентификатор учётной записи Telegram или ${LOGIN_PROVIDERS}, который этот сервис передаёт Сервису при входе, а до входа в веб-приложение — ключ сессии в моём браузере.`,
    },

    { h: '1. Какие данные' },
    {
      ul: [
        'идентификатор, имя и имя пользователя в Telegram, язык интерфейса, часовой пояс;',
        `идентификатор, имя и адрес электронной почты в ${LOGIN_PROVIDERS} — если я вхожу в веб-приложение через них;`,
        'голосовые сообщения и их расшифровка, текст сообщений в Сервисе;',
        'цели и интересы, которые я указываю, и заметки о себе, которые репетитор выделяет из разговора;',
        'результаты проверки уровня языка, словарь, статистика занятий, настройки;',
        'сведения о платежах (без номера банковской карты);',
        'адрес электронной почты или телефон — если я укажу их при оплате, для отправки кассового чека, а почта — ещё и для уведомлений о подписке, если Telegram не подключён или сообщение туда не доставлено.',
      ],
    },

    { h: '2. Зачем' },
    {
      ul: [
        'дать мне доступ к Сервису и его функциям: разговорной практике, исправлению ошибок, словарю, статистике;',
        'подстраивать разговор под мои цели, интересы и уровень;',
        'определять мой уровень языка;',
        'принимать оплату подписки и исполнять договор;',
        'отвечать на мои обращения.',
      ],
    },

    { h: '3. Какие действия' },
    {
      p: 'Сбор, запись, систематизация, накопление, хранение, уточнение, извлечение, использование, передача (предоставление, доступ), обезличивание, блокирование, удаление и уничтожение — автоматизированно, с хранением в базах данных на территории Российской Федерации.',
    },

    { h: '4. Кому Оператор может поручить обработку' },
    {
      p: 'Я согласен на передачу данных, в том числе трансграничную, следующим лицам — только в объёме, нужном для работы Сервиса:',
    },
    {
      ul: [
        ...PROCESSOR_GROUPS.map((p) => `${p.who} — ${p.what}; ${p.why};`),
        `${PAYMENT_PROVIDER} (Россия) — сведения о платеже; приём оплаты и выдача чека.`,
      ],
    },
    {
      p: 'Я понимаю, что в части стран, куда передаются данные, может не обеспечиваться защита персональных данных, равнозначная российской. Наименования и адреса лиц, которым поручена обработка, Оператор сообщает по моему запросу.',
    },

    { h: '5. Срок и отзыв' },
    {
      p: 'Согласие действует, пока у меня есть учётная запись в Сервисе, или до его отзыва. Отозвать согласие можно, написав Оператору в Telegram: {contact}. После отзыва Оператор прекращает обработку и удаляет данные в течение 30 дней, кроме сведений о платежах, которые закон обязывает хранить. Без обработки данных Сервис работать не может, поэтому учётная запись при этом удаляется.',
    },
    { p: 'Подробнее — в [[privacy|Политике обработки персональных данных]].' },
  ],
};
